import { v4 as uuidv4 } from 'uuid';
import { IBox, IBoxRole, IBoxType } from '@app/store/modules/boxes/types';
import { INavItem } from './types';
import { Path, Section } from '@app/const/paths';
import { Direction } from '@app/const/consts';

// Добавление бизнес-ящиков в меню
export const addBoxMenuItems = (menuItems: INavItem[], boxes: IBox[]) => {
  let newMenuItems = [...menuItems];
  if (boxes.length) {
    const boxItems: INavItem[] = boxes
      .filter((val) => val.type !== IBoxType.PERSONAL)
      .map((val) => {
        const items = [
          {
            iconProps: { classes: 'mr-4' },
            route: Path.ENVELOPES_BOX_SETTINGS.replace(':boxOguid', val.oguid),
            title: 'boxes:settings.general.menu',
            uuid: uuidv4(),
            // menuLevel: LibNavItemLevel.LOW,
          },
          ...(val.role === IBoxRole.MANAGER
            ? []
            : [
                {
                  iconProps: { classes: 'mr-4' },
                  route: Path.ENVELOPES_BOX_USERS.replace(
                    ':boxOguid',
                    val.oguid
                  ),
                  title: 'boxes:users.title',
                  uuid: uuidv4(),
                  // level: LibNavItemLevel.LOW,
                },
              ]),
        ];

        const adminPanel: INavItem[] = [
          {
            icon: 'IconCog',
            iconProps: { classes: 'mr-2' },
            route: Section.ENVELOPES_BOX_SETTINGS.replace(
              ':boxOguid',
              val.oguid
            ),
            title: 'boxes:settings.title',
            uuid: uuidv4(),
            // menuLevel: LibNavItemLevel.TOP,
            items: items,
          },
        ];

        return {
          contentData: {
            content: val.email,
            heading: val.companyName,
          },
          iconCollapse: 'IconAngle',
          iconCollapseProps: { classes: 'ml-auto icon-collapse', size: 'xs' },
          items: [
            {
              icon: 'IconIncomingAlt',
              iconProps: { classes: 'mr-2' },
              route: Path.ENVELOPES_BOX_OGUID.replace(
                ':boxOguid',
                val.oguid
              ).replace(':directionOrFolder', Direction.INCOMING),
              title: 'envelopes:incoming',
              uuid: uuidv4(),
            },
            {
              icon: 'IconOutgoingAlt',
              iconProps: { classes: 'mr-2' },
              route: Path.ENVELOPES_BOX_OGUID.replace(
                ':boxOguid',
                val.oguid
              ).replace(':directionOrFolder', Direction.OUTGOING),
              title: 'envelopes:outgoing',
              uuid: uuidv4(),
            },
            ...(val.role === IBoxRole.VIEWER ? [] : adminPanel),
          ],
          route: Section.ENVELOPES_BOX_OGUID.replace(':boxOguid', val.oguid),
          title: val.companyName,
          uuid: uuidv4(),
        };
      });

    newMenuItems = [...newMenuItems, ...boxItems];
  }

  return newMenuItems;
};
